module.exports = __webpack_public_path__ + "static/media/hambalek.7f973a5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/hambalek.jpg
// module id = 553
// module chunks = 0